const shouldSpread = (condition, component) => (condition ? [component] : [])

export default shouldSpread
